// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generalDetalleOrden {
  margin: 1vw;
  /*grid-area: datos;*/
  width: 98%;
  border: 2px solid #9c182d;
  border-radius: 1vw;
  box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);
}

.bodyDetalles {
  padding: 1vw;
}

.encabezadoDetalle {
  display: grid;
  grid-template-areas: "parte1 parte2";
  color: #fff;
  background-color: #282c34;
  border-radius: 0.8vw 0.8vw 0 0;
  height: auto;
}

.ordenDiv {
  grid-area: parte1;
  margin-left: 0.5rem;
}

.statusDiv {
  grid-area: parte2;
  width: 10rem;
  text-align: center;
}

.doctorDetalleOrden {
  background-color: black;
  color: #fff;
  margin-left: 1rem;
  margin-right: 1rem;
  padding-top: 0.4vw;
  padding-left: 0.5vw;
}

.contactoDivDetalle h3 {
  grid-area: titulo;
}

.contacto1Div,
.detalleNuevo {
  margin-left: 1vw;
}

.detalleDiv {
  display: grid;
  grid-template-areas: "parte1 parte2";
}

.detalles1 {
  grid-area: parte1;
}

.detalles2 {
  grid-area: parte2;
}

.divRecoleccion {
  /*grid-area: recoleccion;*/
  margin: 1vw;

  width: 98%;
  border: 2px solid #9c182d;
  border-radius: 1vw;
  box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);
}

.encabezadoRecoleccion {
  display: grid;
  grid-template-areas: "parte1 parte2";
  color: #fff;
  background-color: #282c34;
  border-radius: 0.8vw 0.8vw 0 0;
  height: auto;
}

.textoRecoleccion {
  grid-area: parte1;
  margin-left: 0.5rem;
  align-items: center;
  height: auto;
}

.statusRecoleccionD {
  grid-area: parte2;
  color: #fff;
  width: 90%;
  text-align: center;
  text-transform: uppercase;
}

.recCompletaDetalle{
  width: 100%;
  height: 100%;
  background-color: green;
  color: #fff;
}

.recPendDetalle{
  width: 100%;
  height: 100%;
  background-color: rgb(230, 255, 1);
  color: #0c1b30;
}

.recExDetalle{
  width: 100%;
  height: 100%;
  background-color: rgb(0, 185, 0);
  color: #fff;

}

.recEntDetalle{
  width: 100%;
  height: 100%;
  background-color: rgb(0, 86, 185);
  color: #fff;
}

.lblDetalle{
  font-weight: normal !important;
}

.mensajeroAsignadoD{
  width: 100%;
  height: 100%;
  background-color: red;
}


.botonesRecoleccion {
  grid-template-areas: "seccion1 seccion2";
}

.botonesRec {
  margin: 0.5rem;
  width: 80%;
}

.botones1 {
  grid-area: seccion1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.botones2 {
  grid-area: seccion2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.divRegistro {
  margin: 1vw;
  width: 98%;

  border: 2px solid #9c182d;
  border-radius: 1vw;
  box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);
}

.btnSendRegistro {
  text-align: right;
  margin-top: 0.5vw;
}

.mensajeArea {
  padding: 1vw;
}

.encabezadoRegistro {
  color: #fff;
  background-color: #282c34;
  border-radius: 0.8vw 0.8vw 0 0;
  height: 6vh;
}

.div4 {
  /*grid-area: div4;*/
  margin: 1vw;

  width: 98%;
  border: 2px solid #9c182d;
  border-radius: 1vw;
  box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);
}

.encabezadoDiv4 {
  display: grid;
  grid-template-areas: "seccion1 seccion2";
  background-color: #282c34;
  border-radius: 0.8vw 0.8vw 0 0;
  height: 9vh;
}

.encabezado1 {
  margin: 0.5rem;
  width: auto;
}

.encabezadoDiv4 .form-select {
  width: 90%;
}

.encabezado2 {
  grid-area: seccion2;
  margin: 0.5rem;
  margin-left: 0.5rem;
  width: 80%;
  background-color: yellow;
}

.bodyDiv4,
.bodyRecoleccion {
  padding: 1vw;
}

.contenedorPrincipalOrden {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  height: 85vh;
  margin: 1%;
  padding: 2%;
  background-color: #dbdbdb;
}

.ordenTituloP {
  margin-bottom: 3vh;
  color: #0c1b30;
}

/* Estilo para el contenedor principal del formulario */
.containerOrden {
  overflow: auto;
  max-width: 100%;
  height: 90%;
  overflow-x: hidden;
}

.containerOrden h2 {
  text-align: center;
  margin-top: 1vw;
  margin-bottom: 1vw;
}

/* Estilo para la barra de progreso */
.barraProgreso {
  display: flex;
  justify-content: space-between;
}

/* Estilo para cada paso en la barra de progreso */
.step {
  flex: 1 1;
  border: 2px solid #0c1b30;
  text-align: center;
  line-height: 30px;
  font-size: 2vw;
  margin: 0 10px;
  padding: 0.5vw;
  background-color: #282c34;
  color: #fff;
  font-weight: bold;
  overflow: hidden;
  border-radius: 8%;
}

.textocontaineret {
  font-size: 1.1vw;
  margin-top: -1vw;
  margin-bottom: -1vw;
}

.textoCardStep {
  font-size: 0.7vw;
  font-weight: normal;
}

.btnServiciosTabla {
  margin-top: 2vh;
  margin-bottom: 2vh;
}

.btnServiciosTabla Button {
  background-color: #9c182d;
  border: #9c182d;
  --bs-btn-hover-bg: #801527;
  --bs-btn-hover-border-color: #801527;
}

/* Estilo para el paso activo en la barra de progreso */
.step.active {
  border-color: #0c1b30;
  background-color: #9c182d;
  color: #fff;
}

.botonAntOS,
.botonGuardarServOS,
.botonSigOS {
  display: flex;
  justify-content: center; /* Centrar horizontalmente */
  align-items: center; /* Centrar verticalmente */
}

.buttonsOS {
  margin-top: 1.5%;
  width: 100%;
  height: 9%;
  display: flex;
  justify-content: space-between;
}

.containerImgDiente {
  position: relative;
  width: 100%;
}

.divImgModal {
  position: relative;
}

.imagenDiagrama {
  width: 90%;
  height: 90%;
}
.divOverlay {
  position: absolute;
  width: 81%;
  background-color: rgba(0, 0, 0, 0);
  color: black;
  text-align: center;
  padding: 10px;
  font-size: 170%;
  font-weight: bold;
}

.overlay1 {
  top: 30%;
}

.overlay2 {
  top: 48%;
}

.overlay3 {
  top: 66%;
}

.embed {
  margin-top: 1000px;
  padding-top: 50px;
  padding: 3%;
}

.divAccordion Accordion{
  --bs-accordion-bg: red;
}

.containerElementosDet{
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  margin-top: 1%;
}

.slcOrdenDetalle{
  font-weight: bold !important;
  font-size: large !important;
}

@media screen and (max-width: 768px) {
  .barraProgreso {
    flex-direction: column;
    align-items: center;
    height: 400px;
    overflow: hidden;
    text-align: center;
  }

  .step {
    flex: 1 1;
    margin: 5px;
    text-align: center;
    width: 75%;
    height: 100%;
    font-size: 15px;
    border-radius: 0;
  }

  .textocontaineret {
    font-size: 3vw;
    margin-top: -1vw;
    margin-bottom: -1vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ordenServicio/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAGlB,iDAAiD;AACnD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;;EAEX,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAGlB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,WAAW;;AAEb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;;AAGA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;;EAEV,yBAAyB;EACzB,kBAAkB;EAGlB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;;EAEX,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAGlB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,YAAY;EACZ,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,kDAAkD;AAClD;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,uBAAuB,EAAE,4BAA4B;EACrD,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":[".generalDetalleOrden {\n  margin: 1vw;\n  /*grid-area: datos;*/\n  width: 98%;\n  border: 2px solid #9c182d;\n  border-radius: 1vw;\n  -webkit-box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n  -moz-box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n  box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n}\n\n.bodyDetalles {\n  padding: 1vw;\n}\n\n.encabezadoDetalle {\n  display: grid;\n  grid-template-areas: \"parte1 parte2\";\n  color: #fff;\n  background-color: #282c34;\n  border-radius: 0.8vw 0.8vw 0 0;\n  height: auto;\n}\n\n.ordenDiv {\n  grid-area: parte1;\n  margin-left: 0.5rem;\n}\n\n.statusDiv {\n  grid-area: parte2;\n  width: 10rem;\n  text-align: center;\n}\n\n.doctorDetalleOrden {\n  background-color: black;\n  color: #fff;\n  margin-left: 1rem;\n  margin-right: 1rem;\n  padding-top: 0.4vw;\n  padding-left: 0.5vw;\n}\n\n.contactoDivDetalle h3 {\n  grid-area: titulo;\n}\n\n.contacto1Div,\n.detalleNuevo {\n  margin-left: 1vw;\n}\n\n.detalleDiv {\n  display: grid;\n  grid-template-areas: \"parte1 parte2\";\n}\n\n.detalles1 {\n  grid-area: parte1;\n}\n\n.detalles2 {\n  grid-area: parte2;\n}\n\n.divRecoleccion {\n  /*grid-area: recoleccion;*/\n  margin: 1vw;\n\n  width: 98%;\n  border: 2px solid #9c182d;\n  border-radius: 1vw;\n  -webkit-box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n  -moz-box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n  box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n}\n\n.encabezadoRecoleccion {\n  display: grid;\n  grid-template-areas: \"parte1 parte2\";\n  color: #fff;\n  background-color: #282c34;\n  border-radius: 0.8vw 0.8vw 0 0;\n  height: auto;\n}\n\n.textoRecoleccion {\n  grid-area: parte1;\n  margin-left: 0.5rem;\n  align-items: center;\n  height: auto;\n}\n\n.statusRecoleccionD {\n  grid-area: parte2;\n  color: #fff;\n  width: 90%;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.recCompletaDetalle{\n  width: 100%;\n  height: 100%;\n  background-color: green;\n  color: #fff;\n}\n\n.recPendDetalle{\n  width: 100%;\n  height: 100%;\n  background-color: rgb(230, 255, 1);\n  color: #0c1b30;\n}\n\n.recExDetalle{\n  width: 100%;\n  height: 100%;\n  background-color: rgb(0, 185, 0);\n  color: #fff;\n\n}\n\n.recEntDetalle{\n  width: 100%;\n  height: 100%;\n  background-color: rgb(0, 86, 185);\n  color: #fff;\n}\n\n.lblDetalle{\n  font-weight: normal !important;\n}\n\n.mensajeroAsignadoD{\n  width: 100%;\n  height: 100%;\n  background-color: red;\n}\n\n\n.botonesRecoleccion {\n  grid-template-areas: \"seccion1 seccion2\";\n}\n\n.botonesRec {\n  margin: 0.5rem;\n  width: 80%;\n}\n\n.botones1 {\n  grid-area: seccion1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.botones2 {\n  grid-area: seccion2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.divRegistro {\n  margin: 1vw;\n  width: 98%;\n\n  border: 2px solid #9c182d;\n  border-radius: 1vw;\n  -webkit-box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n  -moz-box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n  box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n}\n\n.btnSendRegistro {\n  text-align: right;\n  margin-top: 0.5vw;\n}\n\n.mensajeArea {\n  padding: 1vw;\n}\n\n.encabezadoRegistro {\n  color: #fff;\n  background-color: #282c34;\n  border-radius: 0.8vw 0.8vw 0 0;\n  height: 6vh;\n}\n\n.div4 {\n  /*grid-area: div4;*/\n  margin: 1vw;\n\n  width: 98%;\n  border: 2px solid #9c182d;\n  border-radius: 1vw;\n  -webkit-box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n  -moz-box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n  box-shadow: 10px 10px 49px -29px rgba(0, 0, 0, 1);\n}\n\n.encabezadoDiv4 {\n  display: grid;\n  grid-template-areas: \"seccion1 seccion2\";\n  background-color: #282c34;\n  border-radius: 0.8vw 0.8vw 0 0;\n  height: 9vh;\n}\n\n.encabezado1 {\n  margin: 0.5rem;\n  width: auto;\n}\n\n.encabezadoDiv4 .form-select {\n  width: 90%;\n}\n\n.encabezado2 {\n  grid-area: seccion2;\n  margin: 0.5rem;\n  margin-left: 0.5rem;\n  width: 80%;\n  background-color: yellow;\n}\n\n.bodyDiv4,\n.bodyRecoleccion {\n  padding: 1vw;\n}\n\n.contenedorPrincipalOrden {\n  border: 1px solid #e0e0e0;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  max-width: 100%;\n  height: 85vh;\n  margin: 1%;\n  padding: 2%;\n  background-color: #dbdbdb;\n}\n\n.ordenTituloP {\n  margin-bottom: 3vh;\n  color: #0c1b30;\n}\n\n/* Estilo para el contenedor principal del formulario */\n.containerOrden {\n  overflow: auto;\n  max-width: 100%;\n  height: 90%;\n  overflow-x: hidden;\n}\n\n.containerOrden h2 {\n  text-align: center;\n  margin-top: 1vw;\n  margin-bottom: 1vw;\n}\n\n/* Estilo para la barra de progreso */\n.barraProgreso {\n  display: flex;\n  justify-content: space-between;\n}\n\n/* Estilo para cada paso en la barra de progreso */\n.step {\n  flex: 1;\n  border: 2px solid #0c1b30;\n  text-align: center;\n  line-height: 30px;\n  font-size: 2vw;\n  margin: 0 10px;\n  padding: 0.5vw;\n  background-color: #282c34;\n  color: #fff;\n  font-weight: bold;\n  overflow: hidden;\n  border-radius: 8%;\n}\n\n.textocontaineret {\n  font-size: 1.1vw;\n  margin-top: -1vw;\n  margin-bottom: -1vw;\n}\n\n.textoCardStep {\n  font-size: 0.7vw;\n  font-weight: normal;\n}\n\n.btnServiciosTabla {\n  margin-top: 2vh;\n  margin-bottom: 2vh;\n}\n\n.btnServiciosTabla Button {\n  background-color: #9c182d;\n  border: #9c182d;\n  --bs-btn-hover-bg: #801527;\n  --bs-btn-hover-border-color: #801527;\n}\n\n/* Estilo para el paso activo en la barra de progreso */\n.step.active {\n  border-color: #0c1b30;\n  background-color: #9c182d;\n  color: #fff;\n}\n\n.botonAntOS,\n.botonGuardarServOS,\n.botonSigOS {\n  display: flex;\n  justify-content: center; /* Centrar horizontalmente */\n  align-items: center; /* Centrar verticalmente */\n}\n\n.buttonsOS {\n  margin-top: 1.5%;\n  width: 100%;\n  height: 9%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.containerImgDiente {\n  position: relative;\n  width: 100%;\n}\n\n.divImgModal {\n  position: relative;\n}\n\n.imagenDiagrama {\n  width: 90%;\n  height: 90%;\n}\n.divOverlay {\n  position: absolute;\n  width: 81%;\n  background-color: rgba(0, 0, 0, 0);\n  color: black;\n  text-align: center;\n  padding: 10px;\n  font-size: 170%;\n  font-weight: bold;\n}\n\n.overlay1 {\n  top: 30%;\n}\n\n.overlay2 {\n  top: 48%;\n}\n\n.overlay3 {\n  top: 66%;\n}\n\n.embed {\n  margin-top: 1000px;\n  padding-top: 50px;\n  padding: 3%;\n}\n\n.divAccordion Accordion{\n  --bs-accordion-bg: red;\n}\n\n.containerElementosDet{\n  text-align: center;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  text-transform: uppercase;\n  margin-top: 1%;\n}\n\n.slcOrdenDetalle{\n  font-weight: bold !important;\n  font-size: large !important;\n}\n\n@media screen and (max-width: 768px) {\n  .barraProgreso {\n    flex-direction: column;\n    align-items: center;\n    height: 400px;\n    overflow: hidden;\n    text-align: center;\n  }\n\n  .step {\n    flex: 1;\n    margin: 5px;\n    text-align: center;\n    width: 75%;\n    height: 100%;\n    font-size: 15px;\n    border-radius: 0;\n  }\n\n  .textocontaineret {\n    font-size: 3vw;\n    margin-top: -1vw;\n    margin-bottom: -1vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
